/**
 * The bookmark a write's answer carries, and a request may bring back, so a
 * client reads its own writes from the database's nearest copy (API.md §1.6,
 * DATA_LAYER_DESIGN §4.3). A header and nothing else: a client keeps the last
 * one it was handed and sends it on every request after. It names a moment in
 * the database, not a person.
 */
export const BOOKMARK_HEADER = 'x-fsp-bookmark';
